var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { runtime } from '../../../classes/runtime/Runtime';
import { xa } from '../../../utils/xa/xa';
export class MenubarRight {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    isPremiumIconHovering = false;
    isReportErrorIconHovering = false;
    isInfoIconHovering = false;
    isStatisticIconHovering = false;
    isMoreIconHovering = false;
    isSettingsIconHovering = false;
    isMultiIconHovering = false;
    isInfoMenuOpen = false;
    isMoreMenuOpen = false;
    isAppInfoModalOpen = false;
    isReportErrorModalOpen = false;
    isPremiumDialogShowing = false;
    isSettingsDialogOpen = false;
    get premiumDialog() {
        return new runtime.availablePackages.Lazy.classes.PremiumDialog(this.parent);
    }
    get reportErrorDialog() {
        return new runtime.availablePackages.Lazy.classes.ReportErrorDialog(this.parent);
    }
    toggleAppInfoDialog() {
        this.isAppInfoModalOpen = !this.isAppInfoModalOpen;
    }
    togglePremiumDialog() {
        this.isPremiumDialogShowing = !this.isPremiumDialogShowing;
    }
    toggleReportErrorDialog() {
        this.isReportErrorModalOpen = !this.isReportErrorModalOpen;
    }
    toggleSettingsDialog() {
        this.isSettingsDialogOpen = !this.isSettingsDialogOpen;
    }
    shouldShowAutoRace = false;
    hasRequestedNumberOfUsers = false;
    get isMultiPlayerMode() {
        if (runtime.isServerRuntime)
            return false;
        if (!this.app.topic)
            return null;
        if (!this.app.appBoot.isInteractiveStable)
            return null;
        if (runtime.solidBrowserRuntime.browserDevice.isSmartphone)
            return null;
        if (runtime.solidBrowserRuntime.browserAddressBar.query.spiel) {
            runtime.runtimeScheduler.addToNextIdleStateChange(() => this.app.appCookies.reactiveCookies.set('multi', '1'));
        }
        const v = this.app.appCookies.reactiveCookies.get('multi');
        if (v === '0')
            return false;
        // auto mode if enough users there
        if (v !== '1' && !this.hasRequestedNumberOfUsers) {
            this.hasRequestedNumberOfUsers = true;
            runtime.runtimeScheduler.addToNextIdleStateChange(async () => {
                const shouldShowAutoRace = await xa.race.shouldShowAutoRace({ topic_id: this.app.topic.id });
                runtime.runtimeScheduler.addToNextIdleStateChange(() => {
                    this.shouldShowAutoRace = shouldShowAutoRace;
                });
            });
        }
        if (v !== '1' && !this.shouldShowAutoRace) {
            return false;
        }
        if (!runtime.streamedPackages.Multi)
            return false;
        if (!runtime.availablePackages.Multi.deepstream.isDeepstreamReady)
            return false;
        if (v !== '1' && this.app.multi.room.roomPresence.usersInRoom.length < 6)
            return false;
        return true;
    }
    set isMultiPlayerMode(b) {
        this.app.appCookies.reactiveCookies.set('multi', b ? '1' : '0');
    }
}
__decorate([
    observable
], MenubarRight.prototype, "isPremiumIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isReportErrorIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isInfoIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isStatisticIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isMoreIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isSettingsIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isMultiIconHovering", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isInfoMenuOpen", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isMoreMenuOpen", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isAppInfoModalOpen", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isReportErrorModalOpen", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isPremiumDialogShowing", void 0);
__decorate([
    observable
], MenubarRight.prototype, "isSettingsDialogOpen", void 0);
__decorate([
    memoize
], MenubarRight.prototype, "premiumDialog", null);
__decorate([
    memoize
], MenubarRight.prototype, "reportErrorDialog", null);
__decorate([
    action.bound
], MenubarRight.prototype, "toggleAppInfoDialog", null);
__decorate([
    action.bound
], MenubarRight.prototype, "togglePremiumDialog", null);
__decorate([
    action.bound
], MenubarRight.prototype, "toggleReportErrorDialog", null);
__decorate([
    action.bound
], MenubarRight.prototype, "toggleSettingsDialog", null);
__decorate([
    observable
], MenubarRight.prototype, "shouldShowAutoRace", void 0);
__decorate([
    computed
], MenubarRight.prototype, "isMultiPlayerMode", null);
